type Translate = (key: string, params: Record<string, number>) => string;

export const formatDuration = (minutes: number, translate: Translate): string => {
  const roundedMinutes = Math.round(minutes);

  if (roundedMinutes < 60) {
    return translate('duration.minutes', { minutes: roundedMinutes });
  }

  return translate('duration.hoursMinutes', {
    hours: Math.floor(roundedMinutes / 60),
    minutes: roundedMinutes % 60,
  });
};
